import * as React from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import { Button } from 'components/ui/button';
import { cn } from 'lib/utils';

type Props = React.ComponentProps<typeof Button> & {
  isOpen: boolean;
};

export const ToggleInvoiceItemsButton = ({ className, isOpen, ...props }: Props) => {
  const ToggleIcon = React.useMemo(
    () => (isOpen ? ChevronUpIcon : ChevronDownIcon),
    [isOpen]
  );

  return (
    <Button
      variant={'outline'}
      className={cn('text-slate-600 text-sm font-GilroySemibold', className)}
      {...props}
    >
      <ToggleIcon className={'w-6 h-6 mr-2'} />
      <span>Itens da NF</span>
    </Button>
  );
};
